import { cn } from "@/lib/utils";

interface DateDisplayProps {
  date: unknown;
  locale?: string;
  className?: string;
}

export default function DateDisplay({
  date,
  locale = "pt-BR",
  className,
}: DateDisplayProps) {
  const parsed =
    typeof date === "string"
      ? new Date(date)
      : date instanceof Date
        ? date
        : new Date(String(date));

  const formatter = new Intl.DateTimeFormat(locale, {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  return (
    <span className={cn("text-sm text-primary-600 dark:text-primary-400", className)}>
      {formatter.format(parsed)}
    </span>
  );
}
